import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { DataTable } from "modules/common";
import { useState } from "react";
import PromoDialog from "./PromoDialog";
import { useCreatePromoMutation, useDeletePromoMutation, useGetPromosQuery } from "api/adminSlice";
import { useTranslation } from "react-i18next";
import { Add } from "@mui/icons-material";
import moment from "moment";

export default function Promos() {
  const { t } = useTranslation()

  const [page, setPage] = useState(1)

  //=================Promo API hooks==================
  const {
    data: promos, isLoading: promosLoading, isFetching: promosFetching, refetch: refetchPromos
  } = useGetPromosQuery({ page, limit: 100 })

  const [createPromo,
    {
      isLoading: createPromoLoading,
      isSuccess: createPromoIsSuccess,
      error: createPromoError,
      reset: createReset
    }
  ] = useCreatePromoMutation()


  const [deletePromo,
    {
      isLoading: deletePromoLoading,
      isSuccess: deletePromoIsSuccess,
      error: deletePromoError,
      reset: deleteReset
    }
  ] = useDeletePromoMutation()

  //==========Get and navigate through promos==========
  const pageChangeHandler = ({ page }) => {
    if (!promosFetching || !promosLoading) {
      setPage(page)
    }
  }

  //===============Handle promo values change==============
  const [promo, setPromo] = useState({
    code: '',
    discount: '',
    expireDate: null
  })

  const resetPromo = () => {
    setPromo({
      code: '',
      discount: '',
      expireDate: null
    })
  }

  const handleChange = ({ target: { value, name } }) => {
    setPromo(prevState => ({ ...prevState, [name]: value }))
  }

  //==============Promo dialog handlers==============
  const [openPromoDialog, setOpenPromoDialog] = useState(false)

  const resetAPIHooks = () => {
    createReset()
    deleteReset()
  }

  const openDialog = (data) => {
    resetAPIHooks()
    if (!!data?.id) {
      setPromo({ ...data, expireDate: moment(data?.expireDate) })
    }
    setOpenPromoDialog(true)
  }

  const closeDialogHandler = () => {
    setOpenPromoDialog(false)
    resetPromo()
  }


  //================Promo CRUD handlers===============
  const createPromoHandler = async (payload) => {
    let response = await createPromo(payload).unwrap()
    checkPromoActionSuccess(response)
  }
  const deletePromoHandler = async (id) => {
    let response = await deletePromo(id).unwrap()
    checkPromoActionSuccess(response)
  }
  const checkPromoActionSuccess = (response) => {
    if (response?.success) {
      refetchPromos()
      setTimeout(() => {
        setOpenPromoDialog(false)
        resetPromo()
      }, 3000);
    }
  }

  const columns = [
    { field: "code", headerName: t("Promo code"), flex: 1 },
    { field: "discount", renderCell: ({ value }) => (<bdi><Typography>{`${value} %`}</Typography></bdi>), headerName: t("Discount"), flex: 1 },
    { field: "expireDate", valueGetter: ({ value }) => moment(value).format("DD/MM/YY"), headerName: t("Expire date"), flex: 1 },
  ];

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" my={25}>
        <Typography variant='h6'>{t("Promo codes")}</Typography>
        {/* <SearchTextFiled
          fullWidth
          label={t("Search")}
          size="small"
          value={searchKey ?? ''}
          onChange={onSearchKey}
        /> */}
        <Button
          startIcon={<Add />}
          sx={{ textTransform: "none" }}
          variant="contained"
          onClick={openDialog}
        >
          {t("Add")}
        </Button>
      </Box>
      <Paper sx={{ height: "80vh" }}>
        <DataTable
          rows={promos?.docs ?? []}
          columns={columns}
          onPaginationModelChange={pageChangeHandler}
          paginationModel={{ page: page - 1, pageSize: 100 }}
          rowCount={promos?.totalDocs ?? 0}
          loading={promosLoading || promosFetching}
          onRowClick={({ row }) => openDialog(row)}
        />
      </Paper>
      <PromoDialog
        openPromoDialog={openPromoDialog}
        loading={createPromoLoading || deletePromoLoading}
        promo={promo}
        handleChange={handleChange}
        onCreatePromo={createPromoHandler}
        onDeletePromo={deletePromoHandler}
        onCloseDialog={closeDialogHandler}
        error={createPromoError || deletePromoError}
        isSuccess={createPromoIsSuccess || deletePromoIsSuccess}
      />
    </Container>
  )
}